// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importa los archivos de traducción
import translationEnUS from './locales/en-US/translation.json';
import translationEsMX from './locales/es-MX/translation.json';
import translationEsCL from './locales/es-CL/translation.json';
import translationPtBR from './locales/pt-BR/translation.json';
import translationEsAR from './locales/es-AR/translation.json';
import translationEsES from './locales/es-ES/translation.json';
import translationItIT from './locales/it-IT/translation.json';
import translationEsPE from './locales/es-PE/translation.json';

// Determinar el idioma según el dominio
const hostname = window.location.hostname.replace(/^www\./, '');
let language = 'en-US'; // Valor por defecto (usa)
if (hostname === 'mevuelo.mx') {
  language = 'es-MX';
} else if (hostname === 'mevuelo.cl') {
  language = 'es-CL';
} else if (hostname === 'voomeu.com') {
  language = 'pt-BR';
} else if (hostname === 'mevuelo.com.ar') {
  language = 'es-AR';
} else if (hostname === 'mevuelo.com.es') {
  language = 'es-ES';
} else if (hostname === 'volamio.com') {
  language = 'it-IT';
} else if (hostname === 'mevuelo.com.pe') {
  language = 'es-PE';
}


// Configuración de los recursos de traducción
const resources = {
  'en-US': {
    translation: translationEnUS
  },
  'es-MX': {
    translation: translationEsMX
  },
  'es-CL': {
    translation: translationEsCL
  },
  'pt-BR': {
    translation: translationPtBR
  },
  'es-AR': {
    translation: translationEsAR
  },
  'es-ES': {
    translation: translationEsES
  },
  'it-IT': { 
    translation: translationItIT 
  },
  'es-PE': {
    translation: translationEsPE
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: 'en-US', // Idioma de respaldo si la clave no se encuentra
    interpolation: {
      escapeValue: false // React ya maneja la seguridad
    }
  });

export default i18n;
